import type { PivotLayoutMeasure } from '@ztechapps/common.contract'
import { PIVOT_AGGREGATION_LABELS } from './constants'
import { isPivotCalculatedMeasure } from '@ztechapps/common.utils'

/** Header label of a layout measure — its name for a calculated value. */
export const toPivotMeasureLabel = (measure: PivotLayoutMeasure): string =>
  isPivotCalculatedMeasure(measure)
    ? measure.field
    : `${PIVOT_AGGREGATION_LABELS[measure.aggregation]} of ${measure.field}`
